import { userPendingActionTypes, projectPhases } from '@/Models.js';
import Resources from '@/Resources.js';

export function getProjectActionLabel(actionType, phase) {
    const isStore = phase === projectPhases.store;
    const projectActionLabels = {
        [userPendingActionTypes.unfinishedCart]: isStore
            ? Resources.BackerCenter.NotificationStoreUnfinishedCartActionLabel
            : Resources.BackerCenter.NotificationUnfinishedCartActionLabel,
        [userPendingActionTypes.pendingEdit]: Resources.BackerCenter.NotificationPendingEditActionLabel,
        [userPendingActionTypes.claimYourGift]: Resources.BackerCenter.NotificationClaimYourGiftActionLabel,
        [userPendingActionTypes.completeYourPledge]: Resources.BackerCenter.NotificationCompletePledgeActionLabel,
        [userPendingActionTypes.completePayment]: isStore
            ? Resources.BackerCenter.NotificationStoreCompletePaymentActionLabel
            : Resources.BackerCenter.NotificationCompletePaymentActionLabel,
        [userPendingActionTypes.viewYourPledge]: Resources.BackerCenter.NotificationViewYourPledgeActionLabel,
        [userPendingActionTypes.settleInstallments]: Resources.BackerCenter.NotificationViewYourPledgeActionLabel,
    };
    return projectActionLabels[actionType];
}
